module.exports = __webpack_public_path__ + "static/media/teltplass.b94913f0.svg";